export default __webpack_public_path__ + "static/media/about14.c3188d30.jpeg";